var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '@airtel/air-design-system';
import React, { forwardRef, useEffect } from 'react';
import { View } from 'react-native';
import { withBoundaries } from '../../hoc';
import { ButtonWidget } from '../button-widget';
import { GridSectionComponent } from '../grid-section/GridSection';
import { getModalSectionStyles } from './ModalSectionStyles';
var ModalSectionComponent = forwardRef((props, ref) => {
  var children = props.children,
    _props$showButtonWidg = props.showButtonWidget,
    showButtonWidget = _props$showButtonWidg === void 0 ? false : _props$showButtonWidg,
    _props$stickyButtonWi = props.stickyButtonWidget,
    stickyButtonWidget = _props$stickyButtonWi === void 0 ? false : _props$stickyButtonWi,
    _props$buttonWidgetPr = props.buttonWidgetProps,
    buttonWidgetProps = _props$buttonWidgetPr === void 0 ? {} : _props$buttonWidgetPr,
    onClosePress = props.onClosePress,
    onOpenMetaData = props.onOpenMetaData,
    onBackMetaData = props.onBackMetaData,
    showBackButton = props.showBackButton,
    onRequestCloseMetaData = props.onRequestCloseMetaData,
    id = props.id,
    onUserAction = props.onUserAction,
    onUnmountHandler = props.onUnmountHandler,
    onUnmountMetaData = props.onUnmountMetaData,
    gridSection = props.gridSection,
    gridSectionProps = props.gridSectionProps,
    restProps = __rest(props, ["children", "showButtonWidget", "stickyButtonWidget", "buttonWidgetProps", "onClosePress", "onOpenMetaData", "onBackMetaData", "showBackButton", "onRequestCloseMetaData", "id", "onUserAction", "onUnmountHandler", "onUnmountMetaData", "gridSection", "gridSectionProps"]);
  var _props$footerStickyIn = props.footerStickyIndex,
    footerStickyIndex = _props$footerStickyIn === void 0 ? -1 : _props$footerStickyIn;
  footerStickyIndex = Number(footerStickyIndex);
  var modalSectionStyles = getModalSectionStyles(props);
  useEffect(() => {
    return () => {
      onUnmountHandler === null || onUnmountHandler === void 0 ? void 0 : onUnmountHandler(Object.assign({
        id
      }, restProps));
      onUnmountMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onUnmountMetaData), Object.assign({}, restProps)));
    };
  }, []);
  var getModalLoadTimeInMiliSeconds = () => {
    return Math.floor(500 + Math.random() * 1000);
  };
  var FooterBtn = () => {
    return _jsx(View, Object.assign({
      style: [modalSectionStyles.buttonWidgetContainer]
    }, {
      children: _jsx(ButtonWidget, Object.assign({
        leftCta: {
          title: 'DONE',
          buttonType: 'primary',
          version: 'fixed-padding'
        },
        onUserAction: onUserAction
      }, buttonWidgetProps, {
        style: [buttonWidgetProps.style, (buttonWidgetProps === null || buttonWidgetProps === void 0 ? void 0 : buttonWidgetProps.showBorderTop) && modalSectionStyles.buttonShowBorderTop]
      }))
    }));
  };
  var footerElement = null;
  var mainContent = children;
  if (footerStickyIndex > -1) {
    var childArray = React.Children.toArray(children);
    footerElement = childArray[footerStickyIndex];
    mainContent = childArray.filter((_, index) => index !== footerStickyIndex);
  }
  if (gridSection) {
    mainContent = _jsx(GridSectionComponent, Object.assign({}, gridSectionProps, {
      children: mainContent
    }));
  }
  return _jsxs(Modal, Object.assign({}, restProps, {
    id: id,
    ref: ref,
    showBackButton: showBackButton,
    onPressBackButton: () => {
      onBackMetaData && onUserAction(Object.assign({
        id
      }, onBackMetaData));
    },
    onOpenHandler: () => {
      var _a;
      (_a = restProps === null || restProps === void 0 ? void 0 : restProps.onOpenHandler) === null || _a === void 0 ? void 0 : _a.call(restProps);
      onOpenMetaData && onUserAction(Object.assign({
        id
      }, onOpenMetaData), {
        loadTimeInMilliseconds: getModalLoadTimeInMiliSeconds()
      });
    },
    onCloseHandler: data => {
      var _a;
      (_a = restProps === null || restProps === void 0 ? void 0 : restProps.onCloseHandler) === null || _a === void 0 ? void 0 : _a.call(restProps, data);
      onClosePress && onUserAction(Object.assign({
        id
      }, onClosePress), data);
    },
    handleOnRequestClose: () => {
      var _a;
      (_a = restProps === null || restProps === void 0 ? void 0 : restProps.handleOnRequestClose) === null || _a === void 0 ? void 0 : _a.call(restProps);
      onRequestCloseMetaData && onUserAction(Object.assign({
        id
      }, onRequestCloseMetaData));
    },
    footerElement: stickyButtonWidget && showButtonWidget && _jsx(FooterBtn, {}) || footerStickyIndex > -1 && _jsx(View, Object.assign({
      style: modalSectionStyles.footerElement
    }, {
      children: footerElement
    }))
  }, {
    children: [mainContent, showButtonWidget && !stickyButtonWidget && _jsx(FooterBtn, {})]
  }));
});
ModalSectionComponent.genericRendererKey = 'AirModalSection';
ModalSectionComponent.isAirSection = true;
export var ModalSection = withBoundaries(ModalSectionComponent);